"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _types = require("../../utils/types");
var _constants = require("../../utils/constants");
var _helpers = require("../../utils/helpers");
var _TwitterListItem = _interopRequireDefault(require("../TwitterListItem/TwitterListItem"));
var _ChatListItem = _interopRequireDefault(require("../ChatListItem/ChatListItem"));
var _ChatItem = _interopRequireDefault(require("../ChatListItem/ChatItem"));
var _MailListItem = _interopRequireDefault(require("../MailListItem/MailListItem"));
var _emptyPlaceholder = _interopRequireDefault(require("../../images/empty-placeholder.png"));
require("./ConversationList.scss");
var _excluded = ["showType", "conversations", "unattendedTimes", "warnings", "selected", "onSelect"],
  _excluded2 = ["selected", "onSelect", "activeMessageId", "onSelectMessage", "type", "messages", "unreadMessage", "contact", "initialTime", "warning", "disabledActions"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ConversationList = function ConversationList(_ref) {
  var showType = _ref.showType,
    _ref$conversations = _ref.conversations,
    conversations = _ref$conversations === void 0 ? [] : _ref$conversations,
    unattendedTimes = _ref.unattendedTimes,
    warnings = _ref.warnings,
    selected = _ref.selected,
    _onSelect = _ref.onSelect,
    msgProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = (0, _reactI18next.useTranslation)(['list', 'commons']),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(conversations),
    _useState2 = _slicedToArray(_useState, 2),
    filteredConversations = _useState2[0],
    setFiltered = _useState2[1];
  (0, _react.useEffect)(function () {
    setFiltered(conversations.filter(function (conversation) {
      return showType === _constants.TABS.HOME || conversation.type === showType;
    }));
  }, [conversations, showType]);
  var emptyPlaceholder = function emptyPlaceholder() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "uin-empty"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "uin-empty-image"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: _emptyPlaceholder["default"],
      alt: "Empty placeholder"
    })), /*#__PURE__*/_react["default"].createElement("p", {
      className: "uin-empty-message"
    }, t('no-conv')));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-conv-list"
  }, filteredConversations.length === 0 ? emptyPlaceholder() : filteredConversations.map(function (conversation) {
    return /*#__PURE__*/_react["default"].createElement(ListItem, _extends({
      key: conversation.campType + '-' + conversation.id,
      selected: conversation.id === selected.convId && conversation.campType === selected.campType,
      onSelect: function onSelect() {
        return _onSelect(conversation.campType, conversation.id);
      },
      timeUnattended: unattendedTimes[conversation.campType][conversation.id],
      warning: warnings[conversation.campType][conversation.id]
    }, msgProps, conversation));
  }));
};
var ListItem = function ListItem(_ref2) {
  var selected = _ref2.selected,
    onSelect = _ref2.onSelect,
    activeMessageId = _ref2.activeMessageId,
    onSelectMessage = _ref2.onSelectMessage,
    type = _ref2.type,
    _ref2$messages = _ref2.messages,
    messages = _ref2$messages === void 0 ? [] : _ref2$messages,
    unreadMessage = _ref2.unreadMessage,
    contact = _ref2.contact,
    initialTime = _ref2.initialTime,
    warning = _ref2.warning,
    disabledActions = _ref2.disabledActions,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var isNewConversation = messages.length === 0;
  var _ref3 = messages[0] || {},
    media = _ref3.media,
    subject = _ref3.subject,
    fcontent = _ref3.content;
  var _ref4 = messages[messages.length - 1] || {},
    ldate = _ref4.date,
    lcontent = _ref4.content;
  var typeMedia = messages && messages[messages.length - 1] && messages[messages.length - 1].type ? messages[messages.length - 1].type : 'text';
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, type === _constants.TABS.TWITTER ? /*#__PURE__*/_react["default"].createElement(_TwitterListItem["default"], _extends({
    active: selected,
    contact: contact,
    date: initialTime,
    media: media,
    text: fcontent,
    unread: isNewConversation || (0, _helpers.hasUnread)(messages),
    onClick: onSelect
  }, props)) : type === _constants.TABS.MAIL ? /*#__PURE__*/_react["default"].createElement(_MailListItem["default"], _extends({
    active: selected,
    unread: isNewConversation || (0, _helpers.hasUnread)(messages),
    contact: contact,
    date: initialTime,
    subject: subject,
    mails: messages,
    activeMail: activeMessageId,
    onClick: onSelect,
    onMailClick: onSelectMessage
  }, props)) : type === _constants.TABS.CHAT ? /*#__PURE__*/_react["default"].createElement(_ChatListItem["default"], _extends({
    active: selected,
    user: contact.name,
    date: ldate || initialTime,
    text: lcontent,
    unread: isNewConversation || (0, _helpers.countUnread)(messages),
    onClick: onSelect,
    typeMedia: typeMedia
  }, props)) : /*#__PURE__*/_react["default"].createElement(_ChatItem["default"], _extends({
    active: selected,
    user: contact.name,
    date: ldate || initialTime,
    text: lcontent,
    unread: isNewConversation || unreadMessage,
    onClick: onSelect,
    type: type,
    typeMedia: typeMedia,
    warning: warning,
    disabledStopwatch: disabledActions
  }, props)));
};
ConversationList.propTypes = {
  showType: _propTypes["default"].string.isRequired,
  conversations: _propTypes["default"].arrayOf(_types.conversationType),
  unattendedTimes: _propTypes["default"].object,
  warnings: _propTypes["default"].object,
  selectedId: _propTypes["default"].number,
  onSelect: _propTypes["default"].func,
  activeMessageId: _propTypes["default"].number,
  onSelectMessage: _propTypes["default"].func
};
ConversationList.defaultProps = {
  unattendedTimes: {},
  warnings: {}
};
var _default = exports["default"] = ConversationList;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/ConversationList/ConversationList.js
// module id = 1399
// module chunks = 0